export default __webpack_public_path__ + "static/media/logo.6cd7af7a.svg";